import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { NotificationService } from '../services/notification.service';

export const httpErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const notificationService = inject(NotificationService);
  const router = inject(Router);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      document.body.style.overflow = 'auto';
      let errorMessage = '';
      if (error?.error?.error?.message) {
        errorMessage = error.error.error.message;
      } else if (error?.error?.message) {
        errorMessage = error.error.message;
      } else if (error?.message) {
        errorMessage = error.message;
      } else {
        errorMessage = 'Unexpected error occurred';
      }
      notificationService.openErrorToast(errorMessage);

      if (error.status === 403 && req.method === 'GET') {
        router.navigateByUrl('/no-access');
      }
      return throwError(() => error);
    })
  );
};
